var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserMenuExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M25.818,14.193l-4.736-4.736c-0.396-0.396-1.039-0.396-1.436,0c-0.396,0.396-0.396,1.039,0,1.436 l3.004,3.004H10.213c-0.561,0-1.016,0.455-1.016,1.016s0.455,1.016,1.016,1.016H22.65l-3.004,3.004 c-0.396,0.396-0.396,1.039,0,1.436c0.199,0.199,0.457,0.297,0.719,0.297c0.258,0,0.52-0.098,0.717-0.297l4.736-4.736 C26.215,15.234,26.215,14.591,25.818,14.193z M14.951,24.049H7.166V5.775h7.785c0.559,0,1.014-0.455,1.014-1.016 s-0.455-1.016-1.014-1.016H6.152c-0.563,0-1.016,0.455-1.016,1.016v20.305c0,0.561,0.453,1.016,1.016,1.016h8.799 c0.559,0,1.014-0.455,1.014-1.016S15.51,24.049,14.951,24.049z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMenuExit);
export default __webpack_public_path__ + "static/media/user_menu_exit.4fe2970747f8530f6889be180affea53.svg";
export { ForwardRef as ReactComponent };